export const BLANK = ' '
